import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { BarChart3, FileText, MessageSquare, LogOut, Plus, Trash2, Send, ChevronLeft, Users, UserPlus, Lock } from 'lucide-react';
import { getInvitations, createAdminInvitation, deleteInvitation } from '../api';
import toast from 'react-hot-toast';
import api from '../api';

const AdminAgents = () => {
  const navigate = useNavigate();
  const [agents, setAgents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({ username: '', password: '', full_name: '' });
  const [creating, setCreating] = useState(false);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('admin_user') || '{}');
    if (user.role !== 'admin') { navigate('/agent'); return; }
    loadAgents();
  }, [navigate]);

  const loadAgents = async () => {
    try {
      const res = await api.get('/auth/agents');
      setAgents(res.data);
    } catch (err) {
      toast.error('Erreur de chargement');
    }
    setLoading(false);
  };

  const handleCreate = async () => {
    if (!formData.username || !formData.password) {
      toast.error('Username et mot de passe requis');
      return;
    }
    setCreating(true);
    try {
      await api.post('/auth/create-agent', formData);
      toast.success('Agent créé');
      setFormData({ username: '', password: '', full_name: '' });
      setShowForm(false);
      loadAgents();
    } catch (err) {
      toast.error(err.response?.data?.message || 'Erreur');
    }
    setCreating(false);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Supprimer cet agent ?')) return;
    try {
      await api.delete(`/auth/agents/${id}`);
      toast.success('Agent supprimé');
      loadAgents();
    } catch (err) {
      toast.error('Erreur');
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_user');
    navigate('/admin');
  };

  if (loading) {
    return <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>Chargement...</div>;
  }

  return (
    <div style={{ minHeight: '100vh', background: '#f8faf8' }}>
      {/* Top bar */}
      <div style={{ background: 'white', borderBottom: '1px solid #e8e8e8', padding: '16px 24px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          <button onClick={() => navigate('/admin/dashboard')} style={{ background: 'none', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px', color: '#666', fontSize: '14px' }}>
            <ChevronLeft size={18} /> Retour
          </button>
          <h1 style={{ fontSize: '18px', fontWeight: '700', color: '#1a1a1a', margin: 0 }}>Gestion des Agents</h1>
        </div>
        <button onClick={handleLogout} style={{ background: 'none', border: 'none', color: '#c62828', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px', fontSize: '14px' }}>
          <LogOut size={16} /> Déconnexion
        </button>
      </div>

      <div style={{ maxWidth: '900px', margin: '0 auto', padding: '24px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <div style={{ fontSize: '14px', color: '#666' }}>{agents.length} agent{agents.length > 1 ? 's' : ''}</div>
          <button onClick={() => setShowForm(!showForm)}
            style={{ background: 'linear-gradient(135deg, #2E7D32, #4CAF50)', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '10px', fontSize: '14px', fontWeight: '600', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px' }}>
            <UserPlus size={16} /> Nouvel agent
          </button>
        </div>

        {showForm && (
          <div style={{ background: 'white', borderRadius: '16px', padding: '20px', marginBottom: '24px', border: '1px solid #e8e8e8' }}>
            <h3 style={{ fontSize: '15px', fontWeight: '700', marginBottom: '12px' }}>Créer un agent</h3>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '12px', marginBottom: '12px' }}>
              <input value={formData.username} onChange={(e) => setFormData({ ...formData, username: e.target.value })} placeholder="Nom d'utilisateur"
                style={{ padding: '10px 12px', borderRadius: '8px', border: '1.5px solid #e0e0e0', fontSize: '14px' }} />
              <input value={formData.full_name} onChange={(e) => setFormData({ ...formData, full_name: e.target.value })} placeholder="Nom complet"
                style={{ padding: '10px 12px', borderRadius: '8px', border: '1.5px solid #e0e0e0', fontSize: '14px' }} />
              <input type="password" value={formData.password} onChange={(e) => setFormData({ ...formData, password: e.target.value })} placeholder="Mot de passe"
                style={{ padding: '10px 12px', borderRadius: '8px', border: '1.5px solid #e0e0e0', fontSize: '14px' }} />
            </div>
            <button onClick={handleCreate} disabled={creating}
              style={{ background: creating ? '#e0e0e0' : '#1B5E20', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '8px', fontSize: '13px', fontWeight: '600', cursor: creating ? 'default' : 'pointer' }}>
              {creating ? 'Création...' : 'Créer l\'agent'}
            </button>
          </div>
        )}

        <div style={{ background: 'white', borderRadius: '16px', border: '1px solid #e8e8e8', overflow: 'hidden' }}>
          {agents.length === 0 ? (
            <p style={{ color: '#888', fontSize: '13px', textAlign: 'center', padding: '40px' }}>Aucun agent créé</p>
          ) : (
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '14px' }}>
              <thead>
                <tr style={{ background: '#f8faf8', borderBottom: '1px solid #e8e8e8' }}>
                  <th style={{ padding: '12px 16px', textAlign: 'left', fontWeight: '600', color: '#666', fontSize: '12px' }}>AGENT</th>
                  <th style={{ padding: '12px 16px', textAlign: 'left', fontWeight: '600', color: '#666', fontSize: '12px' }}>NOM COMPLET</th>
                  <th style={{ padding: '12px 16px', textAlign: 'left', fontWeight: '600', color: '#666', fontSize: '12px' }}>CRÉÉ LE</th>
                  <th style={{ padding: '12px 16px', textAlign: 'right', fontWeight: '600', color: '#666', fontSize: '12px' }}>ACTIONS</th>
                </tr>
              </thead>
              <tbody>
                {agents.map(a => (
                  <tr key={a.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                    <td style={{ padding: '14px 16px', fontWeight: '500', color: '#1a1a1a' }}>{a.username}</td>
                    <td style={{ padding: '14px 16px', color: '#555' }}>{a.full_name || '—'}</td>
                    <td style={{ padding: '14px 16px', color: '#888', fontSize: '13px' }}>{new Date(a.created_at).toLocaleDateString('fr-FR')}</td>
                    <td style={{ padding: '14px 16px', textAlign: 'right' }}>
                      <button onClick={() => handleDelete(a.id)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#c62828' }}>
                        <Trash2 size={16} />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminAgents;
